import { error, info } from '@jutro/logger';
const SumoLogger = require('sumo-logger');
export default function loadSumoLogic(sumoLogicUrl, sourceName, sourceCategory) {
  const opts = {
    endpoint: sumoLogicUrl,
    returnPromise: false,
    sendErrors: true,
    sourceName,
    sourceCategory,
    hostName: window.location.hostname,
    onSuccess: function onSuccess() {
      info('Sumo logic success');
    },
    onError: function onError() {
      error('Sumo logic failed');
    }
  };
  return new SumoLogger(opts);
}